import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
let title = document.getElementsByTagName("title")[0];
const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/liveDetails/:id",
      name: "liveDetails",
      component: (resolve) => require(["@/components/liveDetails"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    // 兼容h5端分享直播间功能，h5端直播间路由是/detail?id=xxxx
    {
      path: "/detail",
      name: "detail",
      component: (resolve) => require(["@/components/liveDetails"], resolve),
      beforeEnter: (to, from, next) => {
        next({ path: "/liveDetails/" + to.query.id });
      },
    },
    {
      path: "/live",
      name: "live",
      component: (resolve) => require(["@/components/live"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/download",
      name: "download",
      component: (resolve) => require(["@/components/download"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/iosAppGuide",
      name: "iosAppGuide",
      component: (resolve) =>
        require(["@/components/iosAppGuide/index"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/information",
      name: "information",
      component: (resolve) => require(["@/components/information"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/subscription",
      name: "subscription",
      component: (resolve) => require(["@/components/subscription"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/competition",
      name: "competition",
      component: (resolve) => require(["@/components/competition"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/anchor",
      name: "anchor",
      component: (resolve) => require(["@/components/anchor"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/tutorial",
      name: "tutorial",
      component: (resolve) => require(["@/components/tutorial"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/advisory",
      name: "advisory",
      component: (resolve) => require(["@/views/Advisory/index.vue"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/advisoryDetails",
      name: "advisoryDetails",
      component: (resolve) =>
        require(["@/views/AdvisoryDetails/index.vue"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/personal",
      name: "personal",
      component: (resolve) => require(["@/components/personal"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/announcementDetails/:id",
      name: "announcementDetails",
      component: (resolve) =>
        require(["@/components/announcementDetails"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "/myLiving",
      name: "myLiving",
      component: (resolve) => require(["@/components/myLiving"], resolve),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: "*",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "page-home" */ "@/components/home"),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js